const convertBinaryToDays = (number) => {
  const days = [];
  for (let i = 1; i < 8; i++) {
    if ((number & (1 << i)) === 1 << i) {
      // enabled
      days.push(i);
    }
  }
  return days;
};

export default convertBinaryToDays;
